document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    event.stopPropagation();
    const input = event.target.closest('input[type="radio"].sr-only');
    if (!input || !input.checked) return;
    
    const label = input.parentNode.querySelector(`label[for="${input.id}"]`);
    if (!label || !label.classList.contains('block-swatch')) return;
   
    const variantOption = label.closest('.variant-picker__option');
    if (!variantOption) return;
   
    const selectedValue = variantOption.querySelector('.selected-value');
    const swatchText = label.querySelector('span')?.textContent?.trim();
    setTimeout(() => {
      selectedValue.textContent = swatchText;
    })
  });
});
